class ProductTabs extends HTMLElement {
	constructor() {
		super();

        this.tab = this.querySelectorAll('.tab-title');
        this.tabContent = this.querySelectorAll('.tab-content');
        this.link = this.querySelectorAll('.toggleLink');

        for (var i = 0; i < this.tab.length; i++) {
            this.tab[i].addEventListener(
                'click',
                this.tabActive.bind(this)
            );
        }

        for (var i = 0; i < this.link.length; i++) {
            this.link[i].addEventListener(
                'click',
                this.tabToggle.bind(this)
            );
        }
	}

    tabActive(event){
        event.preventDefault();
        event.stopPropagation();

        var $this = event.target,
            id = $this.getAttribute('href').replace('#', '');

        if(!$this.classList.contains('is-open')) {
            this.tab.forEach((element, index) => {
                element.classList.remove('is-open');
            });

            $this.classList.add('is-open');

            this.tabContent.forEach((element, index) => {
                if(element.getAttribute('id') == id){
                    element.classList.add('is-active');
                } else {
                    element.classList.remove('is-active');
                }
            });
        }
    }

    tabToggle(event){
        event.preventDefault();
        event.stopPropagation();

        var $this = event.target,
            $content = $this.parentNode.nextElementSibling;
        if($this.classList.contains('is-open')){
            $this.classList.remove('is-open');
            $($content).slideUp('slow');
        } else {
            $this.classList.add('is-open');
            $($content).slideDown('slow');
        }
    }
}

customElements.define('product-tab', ProductTabs);